import React, { useState, useEffect } from "react";
import Joi from "joi-browser";
import Form from "V2.0/components/Form";
import { updateWidget } from "V2.0/HomePages/Widget/service";
import { message } from "antd";

const _ = require("lodash");

export default VoiceEmbed;

function VoiceEmbed(props) {
  const { workspaceId, assistantId, data, onClose, fetchWidget } = props;

  const formFieldforWidget = data;

  const [loading, setLoading] = useState(false);
  const [errorMessageForButton] = useState({});

  const templateForButtonStyle = [
    {
      name: "title",
      label: "Assistant Name",
      type: "text",
    },
    // {
    //   name: "brandColor",
    //   label: "Brand color",
    //   type: "color",
    //   style: "",
    // },
    // {
    //   name: "fontColor",
    //   label: "Font color",
    //   type: "color",
    //   style: "",
    // },
    // {
    //   name: "iconColor",
    //   label: "Icon color",
    //   description: "Specify the color for the icons inside the input field.",
    //   type: "color",
    //   style: "",
    // },
    // {
    //   name: "inputfieldFontColor",
    //   description: "Specify the color for the font inside the input field.",
    //   label: "Font Color",
    //   type: "color",
    //   style: "",
    // },
    // {
    //   name: "question",
    //   description: "Message customers see when the chat is inactive",
    //   label: "Call to Action",
    //   type: "textArea",
    //   style: { height: "80px", fontSize: "13px" },
    // },
    // {
    //   name: "firstMessage",
    //   description: "Message customers see while opening the chat",
    //   label: "First Message",
    //   type: "textArea",
    //   style: { height: "70px", fontSize: "13px" },
    // },
  ];

  const buttonInfoForButton = {
    buttons: "2",
    primaryLabel: "Save",
    secondaryLabel: "Cancel",
  };

  const schemaForButton = {
    // buttonName: Joi.string().allow(null,"").max(5000).label("Button Name"),
    title: Joi.string().label("Asssistant Name"),
    // brandColor: Joi.string().max(5000).label("Button Color"),
    // fontColor: Joi.string().max(5000).label("Font Color"),
    // iconColor: Joi.string().max(5000).label("Icon Color"),
    // inputfieldFontColor: Joi.string().max(5000).label("Icon Color"),
    // firstMessage: Joi.string().max(5000).label("Description of the Assistant"),
    // question: Joi.string().max(50).label("CTA"),

    // // whitelistDomain: Joi.string().max(5000).required().label("WhiteList Doamain"),
    // paddingLR: Joi.string().required().label("Padding Left Right"),
    // paddingTB: Joi.string().required().label("Padding Top Bottom"),
    // fontSize: Joi.string().required().label("fontSize"),
    // width: Joi.string().required().label("Width"),
    // interruptionThreshold: Joi.number().min(-50).max(50).required()
  };

  const handleSubmit = async (data) => {
    // inputValue.title = data.title?data.title:inputValue.title;
    // inputValue.question = data.question?data.question:inputValue.question;
    // inputValue.embedTitle = data.embedTitle?data.embedTitle:inputValue.embedTitle
    // inputValue.bio = data.bio? data.bio:inputValue.bio
    // inputValue.multiStateForm = data.multiStateForm? data.multiStateForm:inputValue.multiStateForm
    // inputValue.initialStateMessage = data.initialStateMessage || data.initialStateMessage===""? data.initialStateMessage:inputValue.initialStateMessage
    // inputValue.buttonText = data.buttonText || data.buttonText===""? data.buttonText:inputValue.buttonText;
    // inputValue.navbarDisplay = sideBar===true?"block":"none"
    // inputValue.formTitle = data.formTitle?data.formTitle:inputValue.formTitle;
    // inputValue.formDescription = data.formDescription?data.formDescription:inputValue.formDescription;
    // inputValue.formHeading = data.formHeading?data.formHeading:inputValue.formHeading;
    // inputValue.formImage = data.formImage?data.formImage:inputValue.formImage;
    // inputValue.firstMessage = data.firstMessage || data.firstMessage===""? data.firstMessage:inputValue.firstMessage;
    // inputValue.imageWidth = data.imageWidth? data.imageWidth:inputValue.imageWidth;

    try {
      const response = await updateWidget({
        workspaceId,
        assistantId,
        payload: data,
      });
      if (response.status === 200) {
        message.success("Configuration saved");
        setLoading(false);
        fetchWidget(false);
        onClose();
      }
    } catch (ex) {
      if (
        ex.response &&
        ex.response.status >= 400 &&
        ex.response.status < 500
      ) {
        setLoading(false);
        message.error(
          ex.response.data?.msg ||
            ex.response.data?.message ||
            ex.response.data?.error ||
            "Failed to save configuration",
        );
        return;
      }
    }
  };

  return (
    <div className="flex">
      <div className="w-full">
        <div className="">
          <Form
            key={JSON.stringify(formFieldforWidget)}
            errorMessage={errorMessageForButton}
            inputField={formFieldforWidget}
            template={templateForButtonStyle}
            schema={schemaForButton}
            buttonInfo={buttonInfoForButton}
            onSubmit={handleSubmit}
            loading={loading}
            setLoading={setLoading}
            handleSecondary={onClose}
          />
        </div>
      </div>
    </div>
  );
}
